import { IConvertGameList, ISlotConverter } from '../../types/converter';
import { IEvoPlayServerGame } from '../../types/interfaces/Slots/EvoPlay';
import { ISlotViewItem } from '../../types/interfaces/Slots/Slots';
import { IGetGameUrl } from '../../types/slot';
import { CasinoType } from 'modules/Casino/types/configuration';
import { getTab } from './EvoPlayUtils';

class Converter implements ISlotConverter {
  convertGameList = ({ data }: IConvertGameList<Record<string, IEvoPlayServerGame>>): ISlotViewItem[] =>
    Object.entries(data ?? {}).map(([id, item]) => ({
      imageUrl: `${location.origin}/evoplay/images/${item.name
        .replace(':', '')
        .replace("'", '')
        .replace('&', 'and')
        .split(' ')
        .map(token => token[0].toUpperCase() + token.slice(1))
        .join('_')}.jpg`,
      gameId: id,
      id,
      provider: 'evoPlay',
      description: item.name,
      routeProvider: 'evoPlay',
      type: CasinoType.slots,
      tab: getTab(item.name, id),
      gameName: item.name,
    }));

  convertGameUrl = ({ data }: IGetGameUrl<string, unknown>) => data;
}

export default Converter;
